import React from 'react';

export default function AppointmentPagination({ page, totalPages, onChange, loading }) {
  if (totalPages <= 1) return null;
  const pages = [...new Set([1, page - 1, page, page + 1, totalPages])].filter((number) => number >= 1 && number <= totalPages).sort((a, b) => a - b);
  return <nav className="pagination-wrapper" aria-label="Randevu sayfaları">
    <button type="button" className="pagination-btn pagination-nav-btn" disabled={loading || page <= 1} onClick={() => onChange(page - 1)}>Önceki</button>
    <div className="pagination-pages">
      {pages.map((number, index) => <React.Fragment key={number}>
        {index > 0 && number - pages[index - 1] > 1 && <span className="pagination-ellipsis">…</span>}
        <button type="button" className={`pagination-btn ${number === page ? 'active' : ''}`} aria-current={number === page ? 'page' : undefined}
          disabled={loading} onClick={() => onChange(number)}>{number}</button>
      </React.Fragment>)}
    </div>
    <button type="button" className="pagination-btn pagination-nav-btn" disabled={loading || page >= totalPages} onClick={() => onChange(page + 1)}>Sonraki</button>
  </nav>;
}
